import React from 'react';
import styled from 'styled-components';

import Section from '../global/section';
import Top from '../top';
import Button from '../global/button';

const StyledContent = styled.div`
	.flex {
		display: flex;
		.tier-col {
			width: calc(50% - 4rem);
			&:last-child {
				width: 50%;
				margin-left: 4rem;
				padding-left: 2rem;
				border-left: 1px solid ${(p) => p.theme.color.light};
			}
			h2 {
				margin-bottom: 2rem;
			}
			.icon-row {
				display: flex;
				padding: 0.5rem 0;
				.icon {
					width: 50px;
					display: flex;
					align-items: center;
					img {
						width: 100%;
					}
				}
				.text {
					width: calc(100% - 50px);
					padding-left: 1rem;
					h3 {
						color: ${(p) => p.theme.color.blue};
						font-weight: 700;
						font-size: 1rem;
					}
					p {
						font-family: ${(p) => p.theme.fonts.serifBody};
					}
				}
			}
			button {
				margin-top: 2rem;
			}
		}
		@media all and (max-width: 768px) {
			flex-wrap: wrap;
			.tier-col {
				width: 100%;
				&:last-child {
					margin-top: 2rem;
					width: 100%;
					margin-left: 0;
					padding-left: 0;
					border-left: none;
				}
			}
		}
	}
`;

export default ({ data }) => {
	const { tier1, tier2 } = data;

	return (
		<StyledContent>
			<Section bg="white">
				<div className="flex">
					<div className="tier-col" id={tier1.id}>
						<Top>{tier1.top}</Top>
						<h2>{tier1.title}</h2>
						{tier1.icons.map((x, i) => (
							<div className="icon-row" key={i}>
								<div className="icon">
									<img src={x.img} alt={`${x.title.toLowerCase()} icon`} />
								</div>
								<div className="text">
									<h3>{x.title}</h3>
									<p>{x.copy}</p>
								</div>
							</div>
						))}
						<Button type="anchor" size="small" bg="red" href={data.id}>
							{tier1.cta.text}
						</Button>
					</div>
					<div className="tier-col" id={tier2.id}>
						<Top>{tier2.top}</Top>
						<h2>{tier2.title}</h2>
						{tier2.icons.map((x, i) => (
							<div className="icon-row" key={i}>
								<div className="icon">
									<img src={x.img} alt={`${x.title.toLowerCase()} icon`} />
								</div>
								<div className="text">
									<h3>{x.title}</h3>
									<p>{x.copy}</p>
								</div>
							</div>
						))}
						<Button type="anchor" size="small" bg="red" href={data.id}>
							{tier2.cta.text}
						</Button>
					</div>
				</div>
			</Section>
		</StyledContent>
	);
};
